import {
  GET_PORTFOLIO_GROUP_DATA, RESET_DEAL_CONNECTOR_AUTH_LINK, GET_PORTFOLIO_DEAL_EMAIL_CONNECTOR_DATA,
  SAVE_PORTFOLIO_GROUP_DATA, VERIFY_PORTFOLIO_DEAL_EMAIL_CONNECTOR, DELETE_PORTFOLIO_GROUP_PORTFOLIO,
} from '../../../constants/system/actions';

const getPortfolioGroupData: Function = (
  payload?: ActionPayload, resolve?: Function, reject?: Function,
): ReduxAction => ({
  type: GET_PORTFOLIO_GROUP_DATA, payload, resolve, reject,
});

const savePortfolioGroupData: Function = (
  payload?: ActionPayload, resolve?: Function, reject?: Function,
): ReduxAction => ({
  type: SAVE_PORTFOLIO_GROUP_DATA, payload, resolve, reject,
});

const getPortfolioDealEmailConnectorData: Function = (
  payload?: ActionPayload, resolve?: Function, reject?: Function,
): ReduxAction => ({
  type: GET_PORTFOLIO_DEAL_EMAIL_CONNECTOR_DATA, payload, resolve, reject,
});

const deletePortfolioGroupPortfolio: Function = (
  payload?: ActionPayload, resolve?: Function, reject?: Function,
): ReduxAction => ({
  type: DELETE_PORTFOLIO_GROUP_PORTFOLIO, payload, resolve, reject,
});

const verifyPortfolioDealEmailConnector: Function = (
  payload?: ActionPayload, resolve?: Function, reject?: Function,
): ReduxAction => ({
  type: VERIFY_PORTFOLIO_DEAL_EMAIL_CONNECTOR, payload, resolve, reject,
});

const resetDealConnectorAuthLink: Function = (payload?: ActionPayload): ReduxAction => ({
  type: RESET_DEAL_CONNECTOR_AUTH_LINK, payload,
});

export {
  getPortfolioGroupData,
  savePortfolioGroupData,
  deletePortfolioGroupPortfolio,
  getPortfolioDealEmailConnectorData,
  verifyPortfolioDealEmailConnector,
  resetDealConnectorAuthLink,
};
